<template>
  <div>
    <div class="row wrapper border-bottom white-bg page-heading">
      <div class="col-xs-12">
        <h2>{{ $t('historic_serie') }}</h2>
        <ol class="breadcrumb">
          <li>
            <router-link :to="{ name: 'dashboard' }">{{
              $t('dashboard')
            }}</router-link>
          </li>
          <li class="active">
            <strong>{{ $t('historic_serie') }}</strong>
          </li>
        </ol>
        <img :src="logo" class="logo-instituicao" />
      </div>
    </div>
    <div class="wrapper wrapper-content animated fadeInDown">
      <div class="row">
        <div class="col-md-12">
          <div class="tabs-container m-b-lg">
            <ul class="nav nav-tabs">
              <li id="serie-privada" class="active">
                <a data-toggle="tab" href="#2">{{ $t('historic_serie') }}</a>
              </li>
            </ul>
            <div class="tab-content">
              <div class="tab-pane active">
                <div class="panel-body">
                  <div class="row">
                    <div class="col-md-3">
                      <div id="cadeia-2" class="form-group">
                        <label class="filtro-title">{{ $t('chain') }}</label>
                        <custom-v-select-box
                          v-model="privada.cadeia"
                          :has-error="disablePrivateSubmit && privada.submitted"
                          :options="optionsPrivateCadeia"
                        />
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div id="grupo-2" class="form-group">
                        <label class="filtro-title">
                          {{ $t('indicator_group') }}
                        </label>
                        <custom-v-select-box
                          v-model="privada.grupo"
                          :has-error="disablePrivateSubmit && privada.submitted"
                          :options="optionsPrivateIndicadorGrupo"
                        />
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div id="indicador-2" class="form-group">
                        <label class="filtro-title">{{
                          $t('indicator')
                        }}</label>
                        <custom-v-select-box
                          v-model="privada.indicador"
                          :has-error="disablePrivateSubmit && privada.submitted"
                          :options="optionsPrivateIndicador"
                        />
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div id="safra-2" class="form-group">
                        <label class="filtro-title">{{ $t('harvest') }}</label>
                        <custom-v-select-box
                          v-model="privada.safra"
                          :has-error="disablePrivateSubmit && privada.submitted"
                          :options="optionsPrivateSafra"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-3">
                      <div id="tipolocalidade-2" class="form-group">
                        <label class="filtro-title">{{
                          $t('historic_serie_view.location_type')
                        }}</label>
                        <custom-v-select-box
                          v-model="privada.tipolocalidade"
                          :has-error="disablePrivateSubmit && privada.submitted"
                          :options="optionsPrivateTipolocalidade"
                        />
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div id="estado-2" class="form-group">
                        <label class="filtro-title">{{ $t('state') }}</label>
                        <custom-v-select-box
                          v-model="privada.estado"
                          :has-error="disablePrivateSubmit && privada.submitted"
                          :options="optionsPrivateEstado"
                          :disable="disableEstado"
                        />
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div id="regiao-2" class="form-group">
                        <label class="filtro-title">{{ $t('region') }}</label>
                        <custom-v-select-box
                          v-model="privada.regiao"
                          :has-error="disablePrivateSubmit && privada.submitted"
                          :options="optionsPrivateRegiao"
                          :disable="disableRegiao"
                        />
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div id="cidade-2" class="form-group">
                        <label class="filtro-title">{{ $t('city') }}</label>
                        <custom-v-select-box
                          v-model="privada.cidade"
                          :has-error="disablePrivateSubmit && privada.submitted"
                          :options="optionsPrivateCidade"
                          :disable="disableCidade"
                        />
                      </div>
                    </div>
                  </div>
                  <div v-if="showDestino" class="row">
                    <div class="col-md-3">
                      <div id="tipolocalidade-2" class="form-group">
                        <label class="filtro-title">
                          {{ $t('dest_location_type') }}
                        </label>
                        <custom-v-select-box
                          v-model="privada.tipolocalidadeDestino"
                          :has-error="disablePrivateSubmit && privada.submitted"
                          :options="optionsPrivateTipolocalidadeDestino"
                        />
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div id="estado-2" class="form-group">
                        <label class="filtro-title">{{
                          $t('dest_state')
                        }}</label>
                        <custom-v-select-box
                          v-model="privada.estadoDestino"
                          :has-error="disablePrivateSubmit && privada.submitted"
                          :options="optionsPrivateEstadoDestino"
                          :disable="disableEstadoDestino"
                        />
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div id="regiao-2" class="form-group">
                        <label class="filtro-title">{{
                          $t('dest_region')
                        }}</label>
                        <custom-v-select-box
                          v-model="privada.regiaoDestino"
                          :has-error="disablePrivateSubmit && privada.submitted"
                          :options="optionsPrivateRegiaoDestino"
                          :disable="disableRegiaoDestino"
                        />
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div id="cidade-2" class="form-group">
                        <label class="filtro-title">{{
                          $t('dest_city')
                        }}</label>
                        <custom-v-select-box
                          v-model="privada.cidadeDestino"
                          :has-error="disablePrivateSubmit && privada.submitted"
                          :options="optionsPrivateCidadeDestino"
                          :disable="disableCidadeDestino"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="disablePrivateSubmit && privada.submitted"
                    class="row"
                  >
                    <div class="col-md-12">
                      <span class="text-danger">{{
                        $t('historic_serie_view.needs_select_one')
                      }}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="hr-line-dashed" />
                  </div>
                  <div v-if="showDatePickers" class="row">
                    <div class="col-md-3">
                      <div
                        id="data-inicio-2"
                        class="form-group"
                        :class="{
                          'has-error': errors.has('privateDate.inicioPrivate')
                        }"
                      >
                        <label
                          >{{ $t('start_date') }}
                          <span
                            v-if="indicadorWarningList"
                            class="glyphicon glyphicon-alert text-warning"
                            :data-title="indicadorWarningList"
                        /></label>
                        <datepicker
                          v-if="privada.show"
                          :start="begginingDate"
                          :change="setDataInicioPrivada"
                          :placeholder="$t('start_date')"
                        />
                        <input
                          v-model="privada.inicio"
                          type="text"
                          hidden
                          name="inicioPrivate"
                          :data-vv-as="$t('start_date')"
                          data-vv-scope="privateDate"
                        />
                        <!-- <span class="text-danger" v-show="errors.has('privateDate.inicioPrivate')">{{ errors.first('privateDate.inicioPrivate') }}</span> -->
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div
                        id="data-fim-2"
                        class="form-group"
                        :class="{
                          'has-error': errors.has('privateDate.fimPrivate')
                        }"
                      >
                        <label class="pretytooltip"
                          >{{ $t('end_date') }}
                        </label>
                        <datepicker
                          v-if="privada.show && privada.showFim"
                          :start="privada.startDate"
                          :change="setDataFimPrivada"
                          :placeholder="$t('end_date')"
                        />
                        <input
                          v-model="privada.fim"
                          type="text"
                          hidden
                          name="fimPrivate"
                          :data-vv-as="$t('end_date')"
                          data-vv-scope="privateDate"
                        />
                        <!-- <span class="text-danger" v-show="errors.has('privateDate.fimPrivate')">{{ errors.first('privateDate.fimPrivate') }}</span> -->
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <a
                        id="download-file-2"
                        class="btn btn-primary"
                        @click="downloadPrivate"
                        >{{ $t('download') }}</a
                      >
                      <a class="btn btn-white" @click="applyFiltersPrivate">{{
                        $t('preview')
                      }}</a>
                      <a
                        id="remove-filters-2"
                        class="btn btn-danger"
                        :disabled="
                          disablePrivateSubmit &&
                            !privada.fim &&
                            !privada.inicio
                        "
                        @click="clearPrivateFilters"
                        >{{ $t('remove_filters') }}</a
                      >
                      <div class="hr-line-dashed" />
                      <h4>{{ $t('historic_serie_view.result_preview') }}</h4>
                      <div class="wrapper-table position-r">
                        <table class="table table-striped">
                          <thead>
                            <tr>
                              <th>{{ $t('date') }}</th>
                              <th>{{ $t('chain') }}</th>
                              <th>{{ $t('indicator_group') }}</th>
                              <th>{{ $t('indicator') }}</th>
                              <th>{{ $t('value') }}</th>
                              <th>{{ $t('unit') }}</th>
                              <th>{{ $t('harvest') }}</th>
                              <th>{{ $t('state') }}</th>
                              <th>{{ $t('region') }}</th>
                              <th>{{ $t('city') }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(item, itemIndex) in privateList"
                              :key="itemIndex"
                            >
                              <td>{{ item.fData || '-' }}</td>
                              <td>{{ item.CadeiaNome || '-' }}</td>
                              <td>{{ item.IndicadorGrupoDescricao || '-' }}</td>
                              <td>{{ item.IndicadorFinalNome || '-' }}</td>
                              <td>{{ item.Valor || '-' }}</td>
                              <td>{{ item.UnidadeSigla || '-' }}</td>
                              <td>{{ item.SafraDescricao || '-' }}</td>
                              <td>{{ item.EstadoNome || '-' }}</td>
                              <td>{{ item.RegiaoNome || '-' }}</td>
                              <td>{{ item.CidadeNome || '-' }}</td>
                            </tr>
                            <tr v-if="privateList.length === 0">
                              <td rowspan="10">{{ $t('no_item_found') }}</td>
                            </tr>
                          </tbody>
                        </table>
                        <div
                          v-if="privateList.length > 0"
                          :class="{ 'blur-table': privateList.length > 1 }"
                        />
                      </div>
                      <div v-if="privateList.length > 0">
                        <p>
                          {{ $t('historic_serie_view.to_view') }}
                          <a class="font-bold" @click="downloadPrivate">{{
                            $t('download')
                          }}</a>
                          {{ $t('historic_serie_view.to_view_end') }}.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert2'
import axios from 'axios'
import baseURL from '@/store/base'
import { baseSteps } from '../../lib/tour'
import hopscotch from 'hopscotch'
import moment from 'moment'
import store from '../../store'
import CustomVSelectBox from '../../shared/custom-v-select-box/CustomVSelectBox.vue'
import Datepicker from '../../components/Datepicker'
import { mapGetters, mapActions } from 'vuex'
import hideLoading from '../../lib/hideLoading'

export default {
  name: 'SerieIndex',
  components: {
    CustomVSelectBox,
    Datepicker
  },
  created() {
    document.title = 'Série Histórica - IMEA'
    this.$analytics.setCurrentScreen(document.title)
    this.$analytics.logEvent('screen_view')

    this.begginingDate = moment()
      .subtract(300, 'years')
      .startOf('year')
      .format('DD/MM/YYYY')
    const str = window.localStorage.getItem('imea.portal.instituicao')
    if (str) {
      const data = JSON.parse(str)
      if (data) {
        this.logo = data.Logo
      }
    }
  },
  mounted() {
    this.selected = this.userInfo.TemSerieHistoricaPrivada ? 2 : 1
    if (!localStorage.tour) {
      this.help()
      localStorage.tour = true
    }

    hideLoading()
  },
  beforeRouteEnter(to, from, next) {
    Promise.all([store.dispatch('ping/requestData')]).then(() => next())
  },
  beforeRouteLeave(to, from, next) {
    hopscotch.endTour(true)
    this.clearPrivateFilters()
    this.clearData()
    next()
  },
  computed: {
    publicDateDiff() {
      const { inicio, fim } = this.publica
      if (!inicio || !fim) return 0
      return moment(fim).diff(inicio, 'years')
    },
    items() {
      return this.data.map(i => {
        i.fData = moment(i.Data).format('L')
        return i
      })
    },
    disablePrivateSubmit() {
      const {
        cadeia,
        grupo,
        indicador,
        tipolocalidade,
        estado,
        regiao,
        cidade,
        safra,
        tipoDestino,
        estadoDestino,
        regiaoDestino,
        cidadeDestino
      } = this.createPrivateParams()
      return !(
        cadeia.length > 0 ||
        grupo.length > 0 ||
        indicador.length > 0 ||
        tipolocalidade.length > 0 ||
        estado.length > 0 ||
        regiao.length > 0 ||
        cidade.length > 0 ||
        safra.length > 0 ||
        tipoDestino.length > 0 ||
        estadoDestino.length > 0 ||
        regiaoDestino.length > 0 ||
        cidadeDestino.length > 0
      )
    },
    privateList() {
      return this.itemsListPublic.map(i => {
        i.fData = moment(i.Data).format('L')
        i.fValor = Number(i.Valor).toFixed(2)
        i.fDataPagamento = '-'
        if (i.MesPagamento && i.AnoPagamento) {
          const formatMes =
            i.MesPagamento < 10 ? `0${i.MesPagamento}` : i.MesPagamento
          i.fDataPagamento = `${formatMes}/${i.AnoPagamento}`
        }
        i.fDataEntrega = '-'
        if (i.MesEntrega && i.AnoEntrega) {
          const formatMes =
            i.MesEntrega < 10 ? `0${i.MesEntrega}` : i.MesEntrega
          i.fDataEntrega = `${formatMes}/${i.AnoEntrega}`
        }
        return i
      })
    },
    itemsListPublic: mapGetters('publico/list', ['items']).items,
    ...mapGetters('selectBox/privateCadeia', [
      'itemsPrivateCadeia',
      'pagePrivateCadeia',
      'pageCountPrivateCadeia',
      'selectedItemsPrivateCadeia'
    ]),
    ...mapGetters('selectBox/privateIndicadorGrupo', [
      'itemsPrivateIndicadorGrupo',
      'pagePrivateIndicadorGrupo',
      'pageCountPrivateIndicadorGrupo',
      'selectedItemsPrivateIndicadorGrupo'
    ]),
    ...mapGetters('selectBox/privateIndicador', [
      'itemsPrivateIndicador',
      'pagePrivateIndicador',
      'pageCountPrivateIndicador',
      'selectedItemsPrivateIndicador'
    ]),
    ...mapGetters('selectBox/privateTipolocalidade', [
      'itemsPrivateTipolocalidade',
      'pagePrivateTipolocalidade',
      'pageCountPrivateTipolocalidade',
      'selectedItemsPrivateTipolocalidade'
    ]),
    ...mapGetters('selectBox/privateEstado', [
      'itemsPrivateEstado',
      'pagePrivateEstado',
      'pageCountPrivateEstado',
      'selectedItemsPrivateEstado'
    ]),
    ...mapGetters('selectBox/privateRegiao', [
      'itemsPrivateRegiao',
      'pagePrivateRegiao',
      'pageCountPrivateRegiao',
      'selectedItemsPrivateRegiao'
    ]),
    ...mapGetters('selectBox/privateCidade', [
      'itemsPrivateCidade',
      'pagePrivateCidade',
      'pageCountPrivateCidade',
      'selectedItemsPrivateCidade'
    ]),
    ...mapGetters('selectBox/privateSafra', [
      'itemsPrivateSafra',
      'pagePrivateSafra',
      'pageCountPrivateSafra',
      'selectedItemsPrivateSafra'
    ]),

    ...mapGetters('menu', ['userInfo'])
  },
  watch: {
    privada: {
      handler: function() {
        this.indicadorWarningList = this.privada.indicador.reduce((acc, v) => {
          if (!v.anos) return acc
          return (
            acc +
            v.text +
            ` - ${this.$t('max_avaliable_date')}: ` +
            this.$d(new Date(v.anos)) +
            '\n'
          )
        }, '')

        this.showDestino = this.privada.indicador.reduce((acc, v) => {
          return acc || v.TemRota
        }, false)

        this.showDatePickers = this.privada.indicador.length
          ? this.privada.indicador.reduce((acc, v) => {
              return v.selected ? !!acc || v.exibirDataSafra : true
            }, false)
          : true

        if (!this.showDatePickers) {
          this.privada.inicio = ''
          this.privada.fim = ''
        }

        this.disableEstado = !this.privada.tipolocalidade.find(
          ({ id }) => id === '3' || id === '2' || id === '1'
        )
        this.disableRegiao = !this.privada.tipolocalidade.find(
          ({ id }) => id === '3' || id === '2'
        )
        this.disableCidade = !this.privada.tipolocalidade.find(
          ({ id }) => id === '3'
        )

        this.disableEstadoDestino = !this.privada.tipolocalidadeDestino.find(
          ({ id }) => id === '3' || id === '2' || id === '1'
        )
        this.disableRegiaoDestino = !this.privada.tipolocalidadeDestino.find(
          ({ id }) => id === '3' || id === '2'
        )
        this.disableCidadeDestino = !this.privada.tipolocalidadeDestino.find(
          ({ id }) => id === '3'
        )
      },
      deep: true
    }
  },
  methods: {
    serilizedAnalyticsData() {
      let serialized = {}
      Object.entries(this.analytics).forEach(([key, value]) => {
        if (Array.isArray(value)) return (serialized[key] = value.sort())
        return (serialized[key] = value)
      })
      return serialized
    },
    getId({ id }) {
      return id
    },
    mapProps({ Page, PageCount, PageSize, Result }, mapFn) {
      if (!mapFn) mapFn = ({ Id, Nome }) => ({ id: Id, text: Nome })
      return {
        page: Page,
        pageCount: PageCount,
        pageSize: PageSize,
        items: Result.map(mapFn)
      }
    },
    setDataInicioPrivada(data) {
      this.analytics.inicio = data ? moment(data).format('YYYY-MM-DD') : data
      this.privada.inicio = data ? moment(data).format('YYYY-MM-DD') : data
      this.privada.startDate = data
        ? moment(data)
            .add(1, 'days')
            .format('DD/MM/YYYY')
        : data
      this.refreshFim('privada')
    },
    setDataFimPrivada(data) {
      this.analytics.fim = data ? moment(data).format('YYYY-MM-DD') : data
      this.privada.fim = data ? moment(data).format('YYYY-MM-DD') : data
    },
    help() {
      hopscotch.startTour(this.tour)
    },
    createPrivateParams() {
      const {
        cadeia,
        grupo,
        indicador,
        tipolocalidade,
        estado,
        regiao,
        cidade,
        tipolocalidadeDestino,
        estadoDestino,
        regiaoDestino,
        cidadeDestino,
        safra,
        inicio,
        fim
      } = this.privada
      return {
        inicio,
        fim,
        cadeia: cadeia.map(this.getId),
        grupo: grupo.map(this.getId),
        indicador: indicador.map(this.getId),
        tipolocalidade: tipolocalidade.map(this.getId),
        estado: estado.map(this.getId),
        regiao: regiao.map(this.getId),
        cidade: cidade.map(this.getId),
        tipoDestino: tipolocalidadeDestino.map(this.getId),
        estadoDestino: estadoDestino.map(this.getId),
        regiaoDestino: regiaoDestino.map(this.getId),
        cidadeDestino: cidadeDestino.map(this.getId),
        safra: safra.map(this.getId)
      }
    },
    downloadPrivate() {
      // this.privada.submitted = true
      // this.$validator.validateAll('privateDate').then(() => {
      //   if (!this.disablePrivateSubmit && this.privateDateDiff <= 3 && this.privada.fim && this.privada.inicio) {
      this.downloadPrivateFile({ ...this.createPrivateParams() }).then(() => {
        this.privada.submitted = false
        swal({
          title: this.$t('historic_serie_view.request_added_to_queue'),
          html: `
          <p>${this.$t('historic_serie_view.request_added_to_queue_detail')}</p>
          <p style="color: #f48044; font-weight: bold;">${this.$t(
            'historic_serie_view.request_added_to_queue_warning'
          )}</p>
          <p>${this.$t(
            'historic_serie_view.request_added_to_queue_change_status'
          )}</p>
        `,
          type: 'success',
          showCancelButton: false,
          confirmButtonClass: 'btn btn-success',
          buttonsStyling: false
        }).catch(() => {})
        this.$analytics.logEvent(
          'download_serie',
          this.serilizedAnalyticsData()
        )
      })
      //   }
      // })
      // .catch(() => {})
    },
    applyFiltersPrivate() {
      // if (!this.disablePrivateSubmit && this.privateDateDiff <= 3 && this.privada.fim && this.privada.inicio) {

      this.requestListPrivate({
        pageSize: 10,
        ...this.createPrivateParams()
      }).then(() => {
        this.privada.previa = true
        this.$analytics.logEvent('preview_serie', this.serilizedAnalyticsData())
      })
      // }
    },
    refreshFim(prop) {
      this[prop].fim = ''
      this[prop].showFim = false
      this.$nextTick(() => {
        this[prop].showFim = true
      })
    },
    clearDatePickers(prop) {
      this[prop].inicio = ''
      this[prop].fim = ''
      this[prop].show = false
      this.$nextTick(() => {
        this[prop].show = true
      })
    },
    clearPrivateFilters() {
      this.privada.cadeia = []
      this.privada.grupo = []
      this.privada.indicador = []
      this.privada.tipolocalidade = []
      this.privada.estado = []
      this.privada.regiao = []
      this.privada.cidade = []
      this.privada.safra = []
      this.privada.tipolocalidadeDestino = []
      this.privada.estadoDestino = []
      this.privada.regiaoDestino = []
      this.privada.cidadeDestino = []
      this.clearDatePickers('privada')
      this.clearListPublic()
      this.clearAnalyticsFilters()
      this.privada.previa = false
    },
    clearAnalyticsFilters() {
      this.analytics.cadeia = []
      this.analytics.grupo = []
      this.analytics.indicador = []
      this.analytics.tipolocalidade = []
      this.analytics.estado = []
      this.analytics.regiao = []
      this.analytics.cidade = []
      this.analytics.safra = []
      this.analytics.tipolocalidadeDestino = []
      this.analytics.estadoDestino = []
      this.analytics.regiaoDestino = []
      this.analytics.cidadeDestino = []
      this.analytics.inicio = ''
      this.analytics.fim = ''
    },
    handleSelect(item, array) {
      if (item.selected) return [...array, item.text]
      return array.filter(val => val !== item.text)
    },
    selectPrivateCadeia(item) {
      this.analytics.cadeia = this.handleSelect(item, this.analytics.cadeia)
      this.privada.grupo = []
      this.privada.indicador = []
      this.privada.tipolocalidade = []
      this.privada.estado = []
      this.privada.regiao = []
      this.privada.cidade = []
      this.privada.safra = []
      this.privada.tipolocalidadeDestino = []
      this.privada.estadoDestino = []
      this.privada.regiaoDestino = []
      this.privada.cidadeDestino = []
    },
    selectPrivateIndicadorGrupo(item) {
      this.analytics.grupo = this.handleSelect(item, this.analytics.grupo)
      this.privada.indicador = []
      this.privada.tipolocalidade = []
      this.privada.estado = []
      this.privada.regiao = []
      this.privada.cidade = []
      this.privada.safra = []
      this.privada.tipolocalidadeDestino = []
      this.privada.estadoDestino = []
      this.privada.regiaoDestino = []
      this.privada.cidadeDestino = []
    },
    selectPrivateIndicador(item) {
      this.analytics.indicador = this.handleSelect(
        item,
        this.analytics.indicador
      )
      this.privada.tipolocalidade = []
      this.privada.estado = []
      this.privada.regiao = []
      this.privada.cidade = []
      this.privada.safra = []
      this.privada.tipolocalidadeDestino = []
      this.privada.estadoDestino = []
      this.privada.regiaoDestino = []
      this.privada.cidadeDestino = []
    },
    selectPrivateSafra(item) {
      this.analytics.safra = this.handleSelect(item, this.analytics.safra)
    },
    selectPrivateTipolocalidade(item) {
      this.analytics.tipolocalidade = this.handleSelect(
        item,
        this.analytics.tipolocalidade
      )
      this.privada.estado = []
      this.privada.regiao = []
      this.privada.cidade = []
    },
    selectPrivateEstado(item) {
      this.analytics.estado = this.handleSelect(item, this.analytics.estado)
      this.privada.regiao = []
      this.privada.cidade = []
    },
    selectPrivateRegiao(item) {
      this.analytics.regiao = this.handleSelect(item, this.analytics.regiao)
      this.privada.cidade = []
    },
    selectPrivateCidade(item) {
      this.analytics.cidade = this.handleSelect(item, this.analytics.cidade)
    },
    selectPrivateTipolocalidadeDestino(item) {
      this.analytics.tipolocalidadeDestino = this.handleSelect(
        item,
        this.analytics.tipolocalidadeDestino
      )
      this.privada.estadoDestino = []
      this.privada.regiaoDestino = []
      this.privada.cidadeDestino = []
    },
    selectPrivateEstadoDestino(item) {
      this.analytics.estadoDestino = this.handleSelect(
        item,
        this.analytics.estadoDestino
      )
      this.privada.regiaoDestino = []
      this.privada.cidadeDestino = []
    },
    selectPrivateRegiaoDestino(item) {
      this.analytics.regiaoDestino = this.handleSelect(
        item,
        this.analytics.regiaoDestino
      )
      this.privada.cidadeDestino = []
    },
    selectPrivateCidadeDestino(item) {
      this.analytics.cidadeDestino = this.handleSelect(
        item,
        this.analytics.cidadeDestino
      )
    },
    loadPrivateCadeia(params) {
      const config = {
        params,
        baseURL,
        method: 'post',
        url: '/cadeia/seriehistoricageral'
      }
      return axios(config).then(({ data }) => this.mapProps(data))
    },
    loadPrivateIndicadorGrupo(params) {
      const { cadeia } = this.createPrivateParams()
      const data = { ...params, cadeia }
      const config = {
        data,
        baseURL,
        method: 'post',
        url: '/indicadorgrupo/seriehistoricageral'
      }

      return axios(config).then(({ data }) =>
        this.mapProps(data, ({ Id, Descricao }) => ({
          id: Id,
          text: Descricao
        }))
      )
    },
    loadPrivateIndicador(params) {
      console.log('Entrei no load Private Indicador')
      const { cadeia, grupo } = this.createPrivateParams()
      const data = { ...params, cadeia, grupo }
      const config = {
        data,
        baseURL,
        method: 'post',
        url: '/indicadorfinal/seriehistoricageral'
      }

      return axios(config).then(({ data }) =>
        this.mapProps(
          data,
          ({ Id, IndicadorNome, Anos, exibirDataSafra, TemRota }) => ({
            id: Id,
            text: IndicadorNome,
            anos: Anos,
            exibirDataSafra,
            TemRota
          })
        )
      )
    },
    loadPrivateTipolocalidade(params) {
      const { cadeia, grupo, indicador } = this.createPrivateParams()
      const data = { ...params, cadeia, grupo, indicador }
      const config = {
        data,
        baseURL,
        method: 'post',
        url: '/tipolocalidade/seriehistoricageral'
      }
      return axios(config).then(({ data }) =>
        this.mapProps(data, ({ Id, Descricao }) => ({
          id: Id,
          text: Descricao
        }))
      )
    },
    loadPrivateEstado(params) {
      const { cadeia, grupo, indicador } = this.createPrivateParams()
      const data = { ...params, cadeia, grupo, indicador }
      const config = {
        data,
        baseURL,
        method: 'post',
        url: '/estado/seriehistoricageral'
      }

      return axios(config).then(({ data }) => this.mapProps(data))
    },
    loadPrivateRegiao(params) {
      const { cadeia, grupo, indicador, estado } = this.createPrivateParams()
      const data = { ...params, cadeia, grupo, indicador, estado }
      const config = {
        data,
        baseURL,
        method: 'post',
        url: '/regiao/seriehistoricageral'
      }

      return axios(config).then(({ data }) => this.mapProps(data))
    },
    loadPrivateCidade(params) {
      const {
        cadeia,
        grupo,
        indicador,
        estado,
        regiao
      } = this.createPrivateParams()
      const data = { ...params, cadeia, grupo, indicador, estado, regiao }
      const config = {
        data,
        baseURL,
        method: 'post',
        url: '/cidade/seriehistoricageral'
      }

      return axios(config).then(({ data }) => this.mapProps(data))
    },
    loadPrivateTipolocalidadeDestino(params) {
      const config = {
        params,
        baseURL,
        method: 'post',
        url: '/tipolocalidade/seriehistoricageral'
      }
      return axios(config).then(({ data }) =>
        this.mapProps(data, ({ Id, Descricao }) => ({
          id: Id,
          text: Descricao
        }))
      )
    },
    loadPrivateEstadoDestino(params) {
      const { cadeia, grupo, indicador } = this.createPrivateParams()
      const data = { ...params, cadeia, grupo, indicador, destino: true }
      const config = {
        data,
        baseURL,
        method: 'post',
        url: '/estado/seriehistoricageral'
      }

      return axios(config).then(({ data }) => this.mapProps(data))
    },
    loadPrivateRegiaoDestino(params) {
      const {
        cadeia,
        grupo,
        indicador,
        estadoDestino
      } = this.createPrivateParams()
      const data = {
        ...params,
        cadeia,
        grupo,
        indicador,
        estado: estadoDestino,
        destino: true
      }
      const config = {
        data,
        baseURL,
        method: 'post',
        url: '/regiao/seriehistoricageral'
      }

      return axios(config).then(({ data }) => this.mapProps(data))
    },
    loadPrivateCidadeDestino(params) {
      const {
        cadeia,
        grupo,
        indicador,
        estadoDestino,
        regiaoDestino
      } = this.createPrivateParams()
      const data = {
        ...params,
        cadeia,
        grupo,
        indicador,
        estado: estadoDestino,
        regiao: regiaoDestino,
        destino: true
      }
      const config = {
        data,
        baseURL,
        method: 'post',
        url: '/cidade/seriehistoricageral'
      }

      return axios(config).then(({ data }) => this.mapProps(data))
    },
    loadPrivateSafra(params) {
      const {
        cadeia,
        grupo,
        indicador,
        estado,
        regiao,
        cidade
      } = this.createPrivateParams()
      const data = {
        ...params,
        cadeia,
        grupo,
        indicador,
        estado,
        regiao,
        cidade
      }
      const config = {
        data,
        baseURL,
        method: 'post',
        url: '/safra/seriehistoricageral'
      }

      return axios(config).then(({ data }) =>
        this.mapProps(data, ({ Id, Descricao }) => ({
          id: Id,
          text: Descricao
        }))
      )
    },

    requestListPrivate: mapActions('publico/list', ['requestData']).requestData,
    clearListPublic: mapActions('publico/list', ['clear']).clear,
    downloadPrivateFile: mapActions('publico/list', ['downloadFile'])
      .downloadFile,
    ...mapActions('downloadSerie', ['clearData']),
    ...mapActions('selectBox/privateCadeia', [
      'clearPrivateCadeia',
      'requestPrivateCadeia',
      'selectItemPrivateCadeia',
      'clearSelectedPrivateCadeia'
    ]),
    ...mapActions('selectBox/privateIndicadorGrupo', [
      'clearPrivateIndicadorGrupo',
      'requestPrivateIndicadorGrupo',
      'selectItemPrivateIndicadorGrupo',
      'clearSelectedPrivateIndicadorGrupo'
    ]),
    ...mapActions('selectBox/privateIndicador', [
      'clearPrivateIndicador',
      'requestPrivateIndicador',
      'selectItemPrivateIndicador',
      'clearSelectedPrivateIndicador'
    ]),
    ...mapActions('selectBox/privateTipolocalidade', [
      'clearPrivateTipolocalidade',
      'requestPrivateTipolocalidade',
      'selectItemPrivateTipolocalidade',
      'clearSelectedPrivateTipolocalidade'
    ]),
    ...mapActions('selectBox/privateEstado', [
      'clearPrivateEstado',
      'requestPrivateEstado',
      'selectItemPrivateEstado',
      'clearSelectedPrivateEstado'
    ]),
    ...mapActions('selectBox/privateRegiao', [
      'clearPrivateRegiao',
      'requestPrivateRegiao',
      'selectItemPrivateRegiao',
      'clearSelectedPrivateRegiao'
    ]),
    ...mapActions('selectBox/privateCidade', [
      'clearPrivateCidade',
      'requestPrivateCidade',
      'selectItemPrivateCidade',
      'clearSelectedPrivateCidade'
    ]),
    ...mapActions('selectBox/privateSafra', [
      'clearPrivateSafra',
      'requestPrivateSafra',
      'selectItemPrivateSafra',
      'clearSelectedPrivateSafra'
    ])
  },
  data() {
    return {
      optionsPrivateCadeia: {
        multi: true,
        locale: this.$i18n.locale === 'en' ? 'enUS' : 'ptBR',
        placeholder: this.$t('select_chain'),
        params: {
          search: 'nome'
        },
        onSelect: this.selectPrivateCadeia,
        load: this.loadPrivateCadeia
      },
      optionsPrivateIndicadorGrupo: {
        multi: true,
        locale: this.$i18n.locale === 'en' ? 'enUS' : 'ptBR',
        placeholder: this.$t('select_group'),
        params: {
          search: 'nome'
        },
        onSelect: this.selectPrivateIndicadorGrupo,
        load: this.loadPrivateIndicadorGrupo
      },
      optionsPrivateIndicador: {
        multi: true,
        locale: this.$i18n.locale === 'en' ? 'enUS' : 'ptBR',
        placeholder: this.$t('select_indicator'),
        params: {
          search: 'nome'
        },
        onSelect: this.selectPrivateIndicador,
        load: this.loadPrivateIndicador
      },
      optionsPrivateTipolocalidade: {
        multi: true,
        locale: this.$i18n.locale === 'en' ? 'enUS' : 'ptBR',
        placeholder: this.$t('select_location_type'),
        params: {
          search: 'nome'
        },
        onSelect: this.selectPrivateTipolocalidade,
        load: this.loadPrivateTipolocalidade
      },
      optionsPrivateEstado: {
        multi: true,
        locale: this.$i18n.locale === 'en' ? 'enUS' : 'ptBR',
        placeholder: this.$t('select_state'),
        params: {
          search: 'nome'
        },
        onSelect: this.selectPrivateEstado,
        load: this.loadPrivateEstado
      },
      optionsPrivateRegiao: {
        multi: true,
        locale: this.$i18n.locale === 'en' ? 'enUS' : 'ptBR',
        placeholder: this.$t('select_region'),
        params: {
          search: 'nome'
        },
        onSelect: this.selectPrivateRegiao,
        load: this.loadPrivateRegiao
      },
      optionsPrivateCidade: {
        multi: true,
        locale: this.$i18n.locale === 'en' ? 'enUS' : 'ptBR',
        placeholder: this.$t('select_city'),
        params: {
          search: 'nome'
        },
        onSelect: this.selectPrivateCidade,
        load: this.loadPrivateCidade
      },
      optionsPrivateTipolocalidadeDestino: {
        multi: true,
        locale: this.$i18n.locale === 'en' ? 'enUS' : 'ptBR',
        placeholder: this.$t('select_location_type'),
        params: {
          search: 'nome'
        },
        onSelect: this.selectPrivateTipolocalidadeDestino,
        load: this.loadPrivateTipolocalidadeDestino
      },
      optionsPrivateEstadoDestino: {
        multi: true,
        locale: this.$i18n.locale === 'en' ? 'enUS' : 'ptBR',
        placeholder: this.$t('select_state'),
        params: {
          search: 'nome'
        },
        onSelect: this.selectPrivateEstadoDestino,
        load: this.loadPrivateEstadoDestino
      },
      optionsPrivateRegiaoDestino: {
        multi: true,
        locale: this.$i18n.locale === 'en' ? 'enUS' : 'ptBR',
        placeholder: this.$t('select_region'),
        params: {
          search: 'nome'
        },
        onSelect: this.selectPrivateRegiaoDestino,
        load: this.loadPrivateRegiaoDestino
      },
      optionsPrivateCidadeDestino: {
        multi: true,
        locale: this.$i18n.locale === 'en' ? 'enUS' : 'ptBR',
        placeholder: this.$t('select_city'),
        params: {
          search: 'nome'
        },
        onSelect: this.selectPrivateCidadeDestino,
        load: this.loadPrivateCidadeDestino
      },
      optionsPrivateSafra: {
        multi: true,
        locale: this.$i18n.locale === 'en' ? 'enUS' : 'ptBR',
        placeholder: this.$t('select_harvest'),
        params: {
          search: 'nome'
        },
        onSelect: this.selectPrivateSafra,
        load: this.loadPrivateSafra
      },
      tour: {
        id: 'dashboard-tour',
        showPrevButton: true,
        i18n: {
          nextBtn: this.$t('historic_serie_view.tour_next'),
          prevBtn: this.$t('historic_serie_view.tour_prev'),
          doneBtn: this.$t('historic_serie_view.tour_done'),
          skipBtn: this.$t('historic_serie_view.tour_skip'),
          closeTooltip: this.$t('historic_serie_view.tour_close'),
          stepNums: ['1', '2', '3']
        },
        steps: baseSteps.concat([
          {
            title: this.$t('historic_serie_view.tour_one_title'),
            content: this.$t('historic_serie_view.tour_one_content'),
            target: 'serie-publica',
            placement: 'bottom'
          },
          {
            title: this.$t('historic_serie_view.tour_two_title'),
            content: this.$t('historic_serie_view.tour_two_content'),
            target: 'serie-privada',
            placement: 'bottom',
            onNext: () => {
              document.querySelector('#serie-publica a').click()
            }
          },
          {
            tab: true,
            title: this.$t('historic_serie_view.tour_three_title'),
            content: this.$t('historic_serie_view.tour_three_content'),
            target: 'cadeia-1',
            placement: 'bottom'
          },
          {
            tab: true,
            title: this.$t('historic_serie_view.tour_four_title'),
            content: this.$t('historic_serie_view.tour_four_content'),
            target: 'grupo-1',
            placement: 'bottom'
          },
          {
            tab: true,
            title: this.$t('historic_serie_view.tour_five_title'),
            content: this.$t('historic_serie_view.tour_five_content'),
            target: 'indicador-1',
            placement: 'bottom'
          },
          {
            tab: true,
            title: this.$t('historic_serie_view.tour_six_title'),
            content: this.$t('historic_serie_view.tour_six_content'),
            target: 'estado-1',
            placement: 'bottom'
          },
          {
            tab: true,
            title: this.$t('historic_serie_view.tour_seven_title'),
            content: this.$t('historic_serie_view.tour_seven_content'),
            target: 'regiao-1',
            placement: 'bottom'
          },
          {
            tab: true,
            title: this.$t('historic_serie_view.tour_eight_title'),
            content: this.$t('historic_serie_view.tour_eight_content'),
            target: 'cidade-1',
            placement: 'bottom'
          },
          {
            tab: true,
            title: this.$t('historic_serie_view.tour_nine_title'),
            content: this.$t('historic_serie_view.tour_nine_content'),
            target: 'safra-1',
            placement: 'bottom'
          },
          {
            tab: true,
            title: this.$t('historic_serie_view.tour_ten_title'),
            content: this.$t('historic_serie_view.tour_ten_content'),
            target: 'data-inicio-1',
            placement: 'bottom'
          },
          {
            tab: true,
            title: this.$t('historic_serie_view.tour_eleven_title'),
            content: this.$t('historic_serie_view.tour_eleven_content'),
            target: 'data-fim-1',
            placement: 'bottom'
          },
          {
            tab: true,
            title: this.$t('historic_serie_view.tour_twelve_title'),
            content: this.$t('historic_serie_view.tour_twelve_content'),
            target: 'remove-filters-1',
            placement: 'bottom'
          },
          {
            tab: true,
            title: this.$t('historic_serie_view.tour_thirteen_title'),
            content: this.$t('historic_serie_view.tour_thirteen_content'),
            target: 'apply-filters-1',
            placement: 'bottom'
          },
          {
            tab: true,
            title: this.$t('historic_serie_view.tour_fourteen_title'),
            content: this.$t('historic_serie_view.tour_fourteen_content'),
            target: 'download-file-1',
            placement: 'bottom'
          },
          {
            tab: true,
            title: this.$t('historic_serie_view.tour_fifteen_title'),
            content: this.$t('historic_serie_view.tour_fifteen_content'),
            target: 'table-1',
            placement: 'top',
            yOffset: -25
          }
        ])
      },
      analytics: {
        cadeia: [],
        grupo: [],
        indicador: [],
        tipolocalidade: [],
        estado: [],
        regiao: [],
        cidade: [],
        tipolocalidadeDestino: [],
        estadoDestino: [],
        regiaoDestino: [],
        cidadeDestino: [],
        safra: [],
        inicio: '',
        fim: ''
      },
      privada: {
        cadeia: [],
        grupo: [],
        indicador: [],
        tipolocalidade: [],
        estado: [],
        regiao: [],
        cidade: [],
        tipolocalidadeDestino: [],
        estadoDestino: [],
        regiaoDestino: [],
        cidadeDestino: [],
        safra: [],
        inicio: '',
        fim: '',
        show: true,
        startDate: '',
        showFim: true,
        submitted: false
      },
      logo: '',
      selected: 1,
      begginingDate: '',
      disableEstado: true,
      disableRegiao: true,
      disableCidade: true,
      disableEstadoDestino: true,
      disableRegiaoDestino: true,
      disableCidadeDestino: true,
      indicadorWarningList: '',
      showDatePickers: true,
      showDestino: false
    }
  }
}
</script>

<style>
.swal2-confirm.btn.btn-success {
  width: 120px;
}

[data-title]:hover:after {
  opacity: 1;
  visibility: visible;
}
[data-title]:after {
  content: attr(data-title);
  background-color: #fff;
  color: #546e7a;
  font-family: 'Open Sans';
  font-size: 13px;
  font-weight: bold;
  text-align: right;
  position: absolute;
  padding: 1px 5px 2px 5px;
  bottom: 120%;
  left: 120%;
  white-space: pre;
  box-shadow: 1px 1px 3px #22222240;
  opacity: 0;
  border: 1px solid #11111110;
  z-index: 99999;
  visibility: hidden;
}
[data-title] {
  position: relative;
}
</style>
